// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QytW","comment":"styles_comment__I5STv"};